module.exports = __webpack_public_path__ + "img/page02_image1.0ba6fdb4.svg";